export default __webpack_public_path__ + "static/media/sponsor-12.5a9c9821.svg";